import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'
import { IAccountUserResponseDto } from 'src/types'

const useRemoveAccountUsers = () => {
  const queryClient = useQueryClient()
  const { accountId } = useParams()

  return useMutation(
    [QUERY_KEYS.ACCOUNT_USERS, accountId],
    async (ids: string[]) => {
      if (!accountId) return null

      return await accountsService.removeAccountUsers(accountId, { ids })
    },
    {
      onSuccess: (data, ids) => {
        if (!data) return

        queryClient.setQueriesData(
          [QUERY_KEYS.ACCOUNT_USERS, accountId],
          (prev?: IAccountUserResponseDto[]) =>
            prev ? prev?.filter((item) => !ids.includes(item.id)) : [],
        )
      },
    },
  )
}

export { useRemoveAccountUsers }
